import { useOrganizationSwitchContext } from "./useOrganizationSwitchContext";

export const useOrganizationSwitch = () => {
  const {
    activeId,
    recentIds,
    haveShownDialog,
    selectActiveOrganization,
    confirmHaveShownDialog
  } = useOrganizationSwitchContext();

  const resolvedActiveId =
    haveShownDialog ? activeId ?? null : recentIds?.[0] ?? null;

  return {
    activeOrganizationId: resolvedActiveId,
    confirmHaveShownDialog,
    hasActiveOrganization: resolvedActiveId !== null,
    haveShownDialog,
    isUsingRecentFallback: !haveShownDialog && !activeId,
    rawActiveOrganizationId: activeId,
    selectActiveOrganization,
    selectionHistory: recentIds,
  };
};
